module.exports = __webpack_public_path__ + "img/icon_sm_fscprk.3506722a.png";